<template>
    <tr ref="thisTableRow">
        <td class="p-3">{{ formatDateTime(tankCardRequest.created_at) }}</td>
        <td class="p-3">
            {{ tankCardRequest.card_type === 'ATRUCK VO VODO' ? 'Truckkaart' :
            (tankCardRequest.card_type === 'AVIA VO VODO' ? 'Tankkaart' :  'AVIA Card')  }}</td>

        <td class="p-3"  v-html="getTankCardOption(tankCardRequest.tank_card_option)"></td>
        <td class="p-3">
            <div v-if="tankCardRequest.license_plate">Kenteken: {{tankCardRequest.license_plate}} <br> </div>
            <div v-if="tankCardRequest.car_info">Auto info: {{ tankCardRequest.car_info}}<br></div>
            <div v-if="tankCardRequest.extra_info">Extra info: {{ tankCardRequest.extra_info}} <br></div>
            <div v-if="tankCardRequest.euro_daily_limit">Daglimiet (€): {{ tankCardRequest.euro_daily_limit}}<br></div>
            <div v-if="tankCardRequest.amount_daily_limit">Daglimiet aantal: {{ tankCardRequest.amount_daily_limit}}<br></div>
            <div v-if="tankCardRequest.euro_week_limit">Weeklimiet (€): {{ tankCardRequest.euro_week_limit}}<br></div>
            <div v-if="tankCardRequest.amount_week_limit">Weeklimiet aantal: {{ tankCardRequest.amount_week_limit}}<br></div>

        <td :class="{'p-3': isDeclined}">
            <template v-if="isDeclined">
                <input class="p-3 decline_reason"
                       type="text"
                       :name="`decline_reason[${tankCardRequest.id}]`"
                       placeholder="Reden afwijzing"
                       v-model="declineReason">
            </template>
        </td>

        <td class="icon-table">
            <span :class="{'btn-avia-icon cursor-pointer': true, 'active': isApproved}" @click="approve">
                <i class="fa fa-check"></i>
            </span>

            <input type="hidden" :name="`approved[${tankCardRequest.id}]`" :value="approved ? 1 : 0">
        </td>

        <td class="icon-table">
            <span :class="{'btn-avia-icon cursor-pointer': true, 'active': isDeclined}" @click="decline">
                <i class="fa fa-times"></i>
            </span>
        </td>

    </tr>
</template>

<script>
    import moment from 'moment';

    export default {
    name: 'TankCardRequestsReviewalTableRow',

    props: {
        tankCardRequest: Object
    },

    data() {
        return {
            approved: null,
            declineReason: ''
        };
    },

    mounted() {
        let $tr = $(this.$refs.thisTableRow),
            totalHeight = $tr.find('.changes').outerHeight() + $tr.find('.reviewer-details').outerHeight();
        $tr.css('height', totalHeight + 'px');
    },

    computed: {
        isApproved() {
            return this.approved === true;
        },

        isDeclined() {
            return this.approved === false;
        },

        isPending() {
            return this.approved === null;
        },

        isReviewed() {
            return this.isApproved || this.declineReason.trim().length > 0;
        },

        changes(){
            return JSON.parse(this.tankCardRequest.changes || null);
        }
    },

    methods: {
        formatDateTime: (date) => (typeof date === 'object' ? date : moment(date)).format('DD/MM/YYYY HH:mm'),

        formatName: (firstName, lastName) => ((firstName || '') + ' ' + (lastName || '')).trim(),

        approve() {
            this.approved = true;
        },

        decline() {
            this.approved = false;
        },
        getTankCardOption(options){
            return options.map(option => `${option}</br>`).join('');
        }
    }
}
</script>

<style lang="scss" scoped>
    td.changes {
        p {
            margin-bottom: 0.5rem;

            &:last-child {
                margin-bottom: 0;
            }
        }
    }



    tr {
        position: relative;
    }

    input.decline_reason {
        width: 100%;
    }
</style>
